import { render, staticRenderFns } from "./PropertyUsage.vue?vue&type=template&id=4f3332da"
import script from "./PropertyUsage.vue?vue&type=script&lang=js"
export * from "./PropertyUsage.vue?vue&type=script&lang=js"
import style0 from "./PropertyUsage.vue?vue&type=style&index=0&id=4f3332da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports